'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _parse = require('parse');

var _parse2 = _interopRequireDefault(_parse);

var _OrderStatus = require('../order/OrderStatus');

var _OrderStatus2 = _interopRequireDefault(_OrderStatus);

var _OrderDetail = require('../cart-view/cart-left/OrderDetail');

var _OrderDetail2 = _interopRequireDefault(_OrderDetail);

var _Utility = require('../../utils/Utility');

var Utils = _interopRequireWildcard(_Utility);

var _MainStore = require('../../stores/MainStore');

var _MainStore2 = _interopRequireDefault(_MainStore);

var _Api = require('../../utils/Api');

var _Api2 = _interopRequireDefault(_Api);

var _Spinner = require('../generic/Spinner');

var _Spinner2 = _interopRequireDefault(_Spinner);

var _CartStore = require('../../stores/CartStore');

var _CartStore2 = _interopRequireDefault(_CartStore);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _Constants = require('../Constants');

var Constants = _interopRequireWildcard(_Constants);

var _dineinIcon = require('../../../img/dinein-icon.gif');

var _dineinIcon2 = _interopRequireDefault(_dineinIcon);

var _deliveryIcon = require('../../../img/delivery-icon.gif');

var _deliveryIcon2 = _interopRequireDefault(_deliveryIcon);

var _pickupIcon = require('../../../img/pickup-icon.gif');

var _pickupIcon2 = _interopRequireDefault(_pickupIcon);

var _tik_green = require('../../../img/tik_green.png');

var _tik_green2 = _interopRequireDefault(_tik_green);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _reactRouterDom = require('react-router-dom');

var _SpinButton = require('../generic/SpinButton');

var _SpinButton2 = _interopRequireDefault(_SpinButton);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EMPTY_ORDER_MSG = "You have not placed any order in past.";
var INIT_ORDER_MSG = "Loading your order....";
var LOGIN_MESSAGE = "Please login again & Refresh...";
var ERROR_ORDER_MSG = "Invalid Session Token! Please try again & refresh the browser.";

var isUtensilsAndNapkins = false;

function withOrderSuccessRouter(Component) {
    function ComponentWithOrderSuccessRouter(props) {
        // const navigate = useNavigate();
        var history = (0, _reactRouterDom.useHistory)();
        var params = (0, _reactRouterDom.useParams)();
        return _react2.default.createElement(Component, _extends({}, props, { history: history, params: params /* other hooks */ }, {
            params: params

        }));
    }
    return ComponentWithOrderSuccessRouter;
}

var OrderSuccessScreen = (0, _createReactClass2.default)({
    displayName: 'OrderSuccessScreen',


    // contextTypes is used to pushed the routes in url
    // contextTypes : {
    //     router : React.PropTypes.object.isRequired
    // },

    getInitialState: function getInitialState() {
        return {
            // view : {
            //     showLoginModal : false
            // },
            orders: {},
            isLoading: false,
            messageString: INIT_ORDER_MSG,
            cartOrderDetail: {},
            view: {
                orderDetail: false,
                showPriceComp: false
            }
        };
    },
    UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
        //scroll to top
        window.scrollTo(0, 0);
        this.setState({ isLoading: true });
    },
    componentWillUnMount: function componentWillUnMount() {
        _CartStore2.default.resetCartOrderDetailsObj();
    },
    getRestaurantAddress: function getRestaurantAddress(locationDetail) {
        if (locationDetail !== null) {
            var locationBar = locationDetail;
            var phoneNumber = locationBar.phoneNumber;
            var addressString1 = locationBar.addLine1;
            var addressString2 = locationBar.city + ', ' + locationBar.state + ' ' + locationBar.zipCode;
            return addressString1 + ',\n ' + addressString2 + '\n ' + Utils.formatPhoneNumber(phoneNumber);
        }
        return null;
    },
    getRestaurantAddressLink: function getRestaurantAddressLink(locationDetail) {
        var restaurantAddress = " 2902 Curry Dr, Valencia, CA 91354";

        if (locationDetail !== null) {
            var locationBar = locationDetail;
            var phoneNumber = locationBar.phoneNumber;
            var addressString1 = locationBar.addLine1;
            var addressString2 = locationBar.city + ', ' + locationBar.state + ' ' + locationBar.zipCode;

            restaurantAddress = addressString1 + ',\n ' + addressString2 + ' ';
        }

        var URI = "http://maps.google.com/?q=" + restaurantAddress;

        return URI;
    },
    getOrderLocationDetail: function getOrderLocationDetail(locId) {
        var index = -1;
        var locationDetail = _MainStore2.default.data.BusinessLocations.filter(function (location, idx) {
            if (location.objectId == locId) {
                index = idx;
                return true;
            }
        })[0];

        return { locationDetail: locationDetail, index: index };
    },
    getOrderLogoImage: function getOrderLogoImage(order) {

        var osObj = order;

        if (osObj.orderType == "DineIn" && osObj.isDineInEnabled) {

            return _dineinIcon2.default;
        } else if (osObj.orderType == "Delivery") {

            return _deliveryIcon2.default;
        } else {

            return _pickupIcon2.default;
        }
    },
    orderTypeMessageConfig: function orderTypeMessageConfig(order) {

        var osObj = order;

        if (osObj.orderType == "DineIn" && osObj.isDineInEnabled) {

            var component = _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'p',
                    { className: 'custom-body-message cart-header' },
                    'Sit back and relax.'
                ),
                _react2.default.createElement(
                    'p',
                    { className: 'custom-body-message-line1 cart-header' },
                    'We\'ll bring the food to your table when it\'s ready!'
                )
            );

            return component;
        } else if (osObj.orderType == "Delivery") {

            if (osObj.scheduledAt) {

                var scheduledTime = Utils.formatDateTimeWithTimeZone(new Date(osObj.scheduledAt.iso), this.props.locationDetail.timeZone);
                var _component = _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'p',
                        { className: 'custom-body-message-line1 cart-header' },
                        'Your order has been scheduled for Delivery on',
                        _react2.default.createElement('br', null),
                        scheduledTime,
                        '.'
                    )
                );

                return _component;
            } else {
                var _component2 = _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'p',
                        { className: 'custom-body-message-line1 cart-header' },
                        'In next few minutes you will be notified when your food will be out for Delivery.'
                    )
                );

                return _component2;
            }
        } else {
            // Pickup for

            if (osObj.scheduledAt) {

                var _scheduledTime = Utils.formatDateTimeWithTimeZone(new Date(osObj.scheduledAt.iso), this.props.locationDetail.timeZone);
                var _component3 = _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'p',
                        { className: 'custom-body-message-line1 cart-header' },
                        'Your order has been scheduled for ',
                        order.orderType,
                        ' on',
                        _react2.default.createElement('br', null),
                        _scheduledTime,
                        '.'
                    )
                );

                return _component3;
            } else {
                var _component4 = _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'p',
                        { className: 'custom-body-message-line1 cart-header' },
                        'In next few minutes you will be notified when your food will be ready for ',
                        order.orderType,
                        '.'
                    )
                );

                return _component4;
            }
        }
    },


    // orderTypeMessageConfig(order){
    //
    //     console.log("locaton: " + JSON.stringify(order))
    //
    //
    //     let osObj = order;
    //
    //     if (osObj.orderType == "DineIn" && osObj.isDineInEnabled) {
    //
    //         let component = (
    //             <React.Fragment>
    //                 <HeadingValue
    //                     heading={`Sit back and relax.`}
    //                     className="text-black"
    //                 />
    //                 <HeadingValue
    //                     className="text-primary"
    //                     value="We'll bring the
    //                     food to your table when it's ready"
    //                 />
    //             </React.Fragment>
    //
    //     );
    //
    //         return component;
    //     }
    //     else if (osObj.orderType == "Delivery"){
    //
    //             if (osObj.scheduledAt) {
    //
    //             let scheduledTime = Utils.formatDateTimeWithTimeZone(new Date(osObj.scheduledAt.iso),this.props.locationDetail.timeZone)
    //                 let component = (
    //                     <HeadingValue
    //                         heading={`Your order has been scheduled for
    //                         Delivery on ${scheduledTime}`}
    //                         className="text-black"
    //                     />
    //                 );
    //
    //                 return component;
    //             }else {
    //                 let component = (
    //
    //                     <HeadingValue
    //                         heading={`In next few minutes you will be notified
    //                          when your food will be out for Delivery`}
    //                         className="text-black"
    //                     />
    //             );
    //
    //                 return component;
    //             }
    //     } else {
    //         // Pickup for
    //
    //         if (osObj.scheduledAt) {
    //
    //             let scheduledTime = Utils.formatDateTimeWithTimeZone(new Date(osObj.scheduledAt.iso),this.props.locationDetail.timeZone)
    //             let component = (
    //                 // <div>
    //                 //     <p className="custom-body-message-line1 cart-header">Your order has been scheduled for {order.orderType} on<br></br>{scheduledTime}.</p>
    //                 // </div>
    //
    //                 <React.Fragment>
    //                     <HeadingValue
    //                         heading={`Your order has been scheduled for ${order.orderType} on`}
    //                         className="text-black"
    //                     />
    //                     <HeadingValue
    //                         className="text-primary"
    //                         value='{scheduledTime}'
    //                     />
    //
    //                 </React.Fragment>
    //
    //
    //             );
    //
    //             return component;
    //         }else {
    //             let component = (
    //                 <div>
    //                     <p className="custom-body-message-line1 cart-header">In next few minutes you will be notified
    //                         when your food will be ready for {order.orderType}.</p>
    //                 </div>
    //             );
    //
    //             return component;
    //         }
    //
    //
    //     }
    //
    // },

    isUtensilsAndNapkins: function isUtensilsAndNapkins() {
        var isUtensils = _MainStore2.default.isLocUtensilsAndNapkinsEnabled();
        if (isUtensils && !(this.state.orderType == Constants.DINEIN)) {
            return true;
        } else {
            return false;
        }
    },
    getOrderTypeStructure: function getOrderTypeStructure(order, locationDetail) {
        var component = null;
        var utensilsAndNapkins = "No";
        var self = this;
        var isDineInEnabled = false;

        if (!Utils.isEmptyObj(order.extraInfo)) {

            var extraInfo = order.extraInfo;
            // check the utensilsAndNapkins key exist or not
            if (Utils.isVariableDefined(extraInfo.utensilsAndNapkins)) {
                isUtensilsAndNapkins = true;

                utensilsAndNapkins = extraInfo.utensilsAndNapkins ? "Yes" : "No";
            }
        }

        if (this.isUtensilsAndNapkins()) {

            component = _react2.default.createElement(
                'div',
                { className: 'col-sm-6 order-detail-right' },
                _react2.default.createElement(
                    'div',
                    { className: 'order-detail-group mb-20' },
                    _react2.default.createElement(
                        'h4',
                        { className: 'item-in-cart' },
                        'Restaurant Address'
                    ),
                    _react2.default.createElement(
                        'a',
                        { href: this.getRestaurantAddressLink(locationDetail),
                            className: 'ft-14',
                            style: { cursor: 'pointer' },
                            tabIndex: 1,
                            target: '_blank',
                            'aria-label': "Restaurant Address Link"
                        },
                        self.getRestaurantAddress(locationDetail)
                    )
                ),
                order.orderInstructions ? _react2.default.createElement(
                    'div',
                    { className: 'order-detail-group' },
                    _react2.default.createElement(
                        'h4',
                        { className: 'item-in-cart' },
                        _react2.default.createElement(
                            'b',
                            null,
                            'Instructions'
                        )
                    ),
                    _react2.default.createElement(
                        'h5',
                        { className: 'text-secondary-light custom-order' },
                        order.orderInstructions
                    )
                ) : null,
                _react2.default.createElement(
                    'div',
                    { className: 'order-detail-group mt-20' },
                    _react2.default.createElement(
                        'h4',
                        { className: 'item-in-cart' },
                        ' Utensils and Napkins'
                    ),
                    _react2.default.createElement(
                        'h5',
                        { className: 'text-secondary-light custom-order' },
                        utensilsAndNapkins
                    )
                )
            );
        } else {
            component = _react2.default.createElement(
                'div',
                { className: 'col-sm-6 order-detail-right' },
                _react2.default.createElement(
                    'div',
                    { className: 'order-detail-group mb-20' },
                    _react2.default.createElement(
                        'h4',
                        { className: 'item-in-cart' },
                        'Restaurant Details'
                    ),
                    _react2.default.createElement(
                        'a',
                        { href: this.getRestaurantAddressLink(locationDetail),
                            className: 'ft-14',
                            style: { cursor: 'pointer' },
                            tabIndex: 1,
                            target: '_blank',
                            'aria-label': "Restaurant Address Link"
                        },
                        self.getRestaurantAddress(locationDetail)
                    )
                ),
                order.orderInstructions ? _react2.default.createElement(
                    'div',
                    { className: 'order-detail-group' },
                    _react2.default.createElement(
                        'h4',
                        { className: 'item-in-cart' },
                        _react2.default.createElement(
                            'b',
                            null,
                            'Instructions'
                        )
                    ),
                    _react2.default.createElement(
                        'h5',
                        { className: 'text-secondary-light custom-order' },
                        order.orderInstructions
                    )
                ) : null
            );
        }

        return component;
    },
    getOrderDetails: function getOrderDetails(order) {

        var component = null;
        var utensilsAndNapkins = "No";
        var self = this;
        var isDineInEnabled = false;

        if (order.orderType == "PickUp" && !Utils.isEmptyObj(order.curbsidePickup)) {
            component =
            // <div className="custom-order-details-right 6">
            _react2.default.createElement(
                'div',
                { className: 'order-detail-group mt-20 ' },
                _react2.default.createElement(
                    'h4',
                    { className: 'item-in-cart' },
                    'Vehicle Details'
                ),
                _react2.default.createElement(
                    'h5',
                    { className: 'text-secondary-light item-in-cart' },
                    ' ',
                    order.curbsidePickup.vColor,
                    ',',
                    " ",
                    ' ',
                    order.curbsidePickup.vMakeModel
                )
            )

            // </div>
            ;
        } else {
            component = null;
        }

        if (order.orderType == "Delivery") {

            // const order       = this.props.order;
            var currentUser = _parse2.default.User.current();
            var address = "";

            if (order === null) {
                return "";
            }

            if (!Utils.isEmptyObj(currentUser)) {
                address = currentUser.get("name") + ',' + order.deliveryAddLine1 + '\n                ' + order.deliveryAddLine2 + ', ' + order.deliveryCity + ', ' + order.deliveryState + ' ' + order.deliveryZip + '\n                ' + Utils.formatPhoneNumber(order.deliveryPhone);
            } else {
                address = order.userInfo.name + ', ' + order.deliveryAddLine1 + '\n                ' + order.deliveryAddLine2 + ', ' + order.deliveryCity + ', ' + order.deliveryState + ' ' + order.deliveryZip + '\n                ' + Utils.formatPhoneNumber(order.deliveryPhone);
            }

            component = _react2.default.createElement(
                'div',
                { className: 'order-detail-group mt-20' },
                _react2.default.createElement(
                    'h4',
                    { className: 'item-in-cart' },
                    'Delivery Address'
                ),
                _react2.default.createElement(
                    'h5',
                    { className: 'text-secondary-light item-in-cart' },
                    address
                )
            );
        }

        if (order.orderType == "DineIn" && !Utils.isEmptyObj(order.dineIn)) {

            order.orderType = "DineIn";

            isDineInEnabled = true;

            var slData = null;
            var dispStr = "";

            if (order.dineIn && order.dineIn.serviceLocation) {
                dispStr = order.dineIn.serviceLocation;
            } else {
                dispStr = "Table";
            }

            if (order.dineIn && order.dineIn.slData) {
                slData = order.dineIn.slData;
            } else if (order.dineIn && order.dineIn.tableNumber) {
                slData = order.dineIn.tableNumber;
            } else {
                slData = "Not Available";
            }

            component = _react2.default.createElement(
                'div',
                { className: 'order-detail-group mt-20' },
                _react2.default.createElement(
                    'h4',
                    { className: 'item-in-cart' },
                    'Room Number Testing'
                ),
                _react2.default.createElement(
                    'h5',
                    { className: 'text-secondary-light item-in-cart' },
                    slData
                )
            );
        }

        return component;
    },
    goToMyOrders: function goToMyOrders() {

        var currentUser = _parse2.default.User.current();

        if (!Utils.isEmptyObj(currentUser)) {
            var activeLocation = _MainStore2.default.getActiveLocation();
            var locationObjectId = activeLocation.objectId;

            //after success route to order-screen
            // this.context.router.push('/location/' + locationObjectId + '/myOrders');
        } else {
            this.setState(function (prevState) {
                return {
                    view: {
                        orderDetail: !prevState.view.orderDetail
                    }
                };
            }, function () {
                Constants.scrollToTop('order-detail');
            });
        }
    },
    getOrderStructure: function getOrderStructure() {
        var component = null;
        var order = this.props.order;

        if (!Utils.isEmptyObj(order)) {

            var orderLocId = order.orderDetail.locationDetailPointer.objectId;
            // const { locationDetail } = this.getOrderLocationDetail(orderLocId);

            component = _react2.default.createElement(
                'ul',
                { className: 'list-group' },
                _react2.default.createElement(
                    'li',
                    { className: 'mt-3 border-0' },
                    _react2.default.createElement(
                        'div',
                        { className: 'container' },
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'div',
                                { className: "custom-header" },
                                _react2.default.createElement(
                                    'p',
                                    { className: 'custom-header-label cart-header' },
                                    'Hey ',
                                    order.orderDetail.userInfo.name,
                                    '!'
                                ),
                                _react2.default.createElement(
                                    'p',
                                    { className: 'custom-header-message cart-header' },
                                    'Your Order has been placed.'
                                )
                            ),

                            // this.state.showOrderPlacedIcon ? (
                            _react2.default.createElement(
                                'div',
                                { className: 'order-logo-image' },
                                _react2.default.createElement('img', { src: this.getOrderLogoImage(order.orderDetail),
                                    alt: 'order success gif',
                                    title: ''
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: "custom-body pt-0" },
                                this.orderTypeMessageConfig(order.orderDetail),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'order-success-image' },
                                    _react2.default.createElement('img', { src: _tik_green2.default,
                                        alt: 'success',
                                        title: 'order confirmed' })
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-12  order-group-container text-left', id: 'order-detail' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'order-detail-container' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'text-center' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'order-detail-group' },
                                            _react2.default.createElement(
                                                'h3',
                                                { className: 'item-in-container ' },
                                                _react2.default.createElement(
                                                    'b',
                                                    null,
                                                    'Order#:'
                                                ),
                                                ' ',
                                                order.orderNum
                                            ),
                                            _react2.default.createElement(
                                                'h3',
                                                { className: 'item-in-container' },
                                                _react2.default.createElement(
                                                    'b',
                                                    null,
                                                    order.orderDetail.itemCount,
                                                    ' Items:'
                                                ),
                                                '  $',
                                                order.orderDetail.totalAmount,
                                                ' '
                                            ),
                                            _react2.default.createElement(
                                                'h3',
                                                { className: 'item-in-container' },
                                                _react2.default.createElement(
                                                    'b',
                                                    null,
                                                    order.orderDetail.orderType == "PickUp" && !Utils.isEmptyObj(order.orderDetail.curbsidePickup) ? "Curbside Pickup" : _react2.default.createElement(
                                                        'span',
                                                        null,
                                                        order.orderDetail.orderType
                                                    )
                                                )
                                            )
                                        ),
                                        !_parse2.default.User.current() ? this.getOrderDetails(order.orderDetail) : null
                                    )
                                )
                            ),
                            this.state.view.orderDetail ? _react2.default.createElement(_OrderDetail2.default, {
                                itemDetails: this.props.itemDetails
                                // locTax      = {self.getTaxInfo(locationDetail)}
                                , orderDetail: order.orderDetail,
                                order: order.orderDetail
                            }) : null
                        )
                    )
                )
            );
        }

        return component;
    },
    renderItemsDetail: function renderItemsDetail() {
        var order = this.props.order;
        var itemDetail = order.orderDetail.items;

        return _react2.default.createElement(
            _react2.default.Fragment,
            null,
            itemDetail.map(function (el, index) {
                return _react2.default.createElement(
                    'tr',
                    { key: "id" + index },
                    _react2.default.createElement(
                        'td',
                        null,
                        el.itemName
                    ),
                    _react2.default.createElement(
                        'td',
                        { className: 'text-right' },
                        el.itemQty
                    ),
                    _react2.default.createElement(
                        'td',
                        { className: 'text-right' },
                        '$',
                        el.itemPrice
                    )
                );
            })
        );
    },
    handleOrderSuccess: function handleOrderSuccess() {
        var currentUser = _parse2.default.User.current();
        var history = this.props.history;


        var locId = this.props.params.locId;
        history.push('/location/' + this.props.params.locId + '/orders');
    },
    getCouponStructure: function getCouponStructure(order) {
        var couponInfo = order.couponInfo;

        if (couponInfo && !Utils.isEmptyObj(couponInfo)) {
            var component = _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement(
                        'td',
                        { className: 'text-right disc-highlight', colSpan: '2' },
                        'Applied coupon :'
                    ),
                    _react2.default.createElement(
                        'td',
                        { className: "text-right disc-highlight" },
                        _react2.default.createElement(
                            'b',
                            null,
                            couponInfo.couponCode
                        ),
                        ' for this order.'
                    )
                ),
                _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement(
                        'td',
                        { className: 'text-right', colSpan: '2' },
                        'Sub Total:'
                    ),
                    _react2.default.createElement(
                        'td',
                        { className: 'text-right' },
                        ' $',
                        Utils.toRoundStr(order.subTotal, 2)
                    )
                ),
                _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement(
                        'td',
                        { className: 'text-right disc-highlight', colSpan: '2' },
                        'Discount:'
                    ),
                    _react2.default.createElement(
                        'td',
                        { className: 'text-right disc-highlight' },
                        ' -$',
                        Number(couponInfo.discountAmount).toFixed(2)
                    )
                ),
                _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement(
                        'td',
                        { className: 'text-right font-weight-bold', colSpan: '2' },
                        'Discounted Sub Total:'
                    ),
                    _react2.default.createElement(
                        'td',
                        { className: 'text-right font-weight-bold' },
                        ' $',
                        Number(order.subTotal - couponInfo.discountAmount).toFixed(2)
                    )
                )
            );
            return component;
        } else {
            return _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                    'td',
                    { className: 'text-right', colSpan: '2' },
                    'Sub Total:'
                ),
                _react2.default.createElement(
                    'td',
                    { className: 'text-right' },
                    ' $',
                    Utils.toRoundStr(order.subTotal, 2)
                )
            );
        }
    },
    getDeliveryFeeStructure: function getDeliveryFeeStructure(order) {
        var component = null;

        if (order.deliveryFee) {
            component = _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                    'td',
                    { className: 'text-right', colSpan: '2' },
                    'Delivery Fee:'
                ),
                _react2.default.createElement(
                    'td',
                    { className: 'text-right' },
                    ' $',
                    Utils.toRoundStr(order.deliveryFee, 2)
                )
            );
        }

        return component;
    },
    getServiceFeeStructure: function getServiceFeeStructure(order) {
        var component = null;

        if (order.serviceFee) {
            component = _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                    'td',
                    { className: 'text-right', colSpan: '2' },
                    'Service Fee:'
                ),
                _react2.default.createElement(
                    'td',
                    { className: 'text-right' },
                    ' $',
                    Utils.toRoundStr(order.serviceFee, 2)
                )
            );
        }

        return component;
    },
    getDriverTipStructure: function getDriverTipStructure(order) {
        var component = null;
        if (order.tipAmount) {
            component = _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                    'td',
                    { className: 'text-right', colSpan: '2' },
                    'Tip:'
                ),
                _react2.default.createElement(
                    'td',
                    { className: 'text-right' },
                    ' $',
                    _lodash2.default.round(order.tipAmount || 0, 2).toFixed(2)
                )
            );
        }
        return component;
    },
    getCustomChargeStructure: function getCustomChargeStructure(order) {

        var customCharges = order.charge;
        if (customCharges != undefined && customCharges.length > 0) {

            return customCharges.map(function (charge, index, array) {

                var descComponent = null;
                if (!Utils.isEmpty(charge.desc)) {
                    descComponent = _react2.default.createElement(
                        'span',
                        null,
                        _react2.default.createElement(
                            'a',
                            { 'data-tip': charge.desc, className: 'color-styl tooltip-button',
                                style: { cursor: 'pointer' } },
                            _react2.default.createElement('i', {
                                className: 'fa fa-info-circle'
                            })
                        ),
                        _react2.default.createElement(_reactTooltip2.default, { place: 'right', wrapper: 'span' })
                    );
                }

                return _react2.default.createElement(
                    'tr',
                    { key: index },
                    _react2.default.createElement(
                        'td',
                        { className: 'text-right', colSpan: '2' },
                        charge.name,
                        ' ',
                        descComponent
                    ),
                    _react2.default.createElement(
                        'td',
                        { className: 'text-right' },
                        ' $',
                        Utils.toRoundStr(charge.fee, 2)
                    )
                );
            });
        }
    },
    redirectToMainPage: function redirectToMainPage() {
        var locId = this.props.params.locId;
        var history = this.props.history;
        // Navigate to Another Component
        // history.push("/location/" + locId);

        history.push({
            pathname: "/location/" + locId,
            resetStore: false
        });
    },
    render: function render() {
        var self = this;
        var title = "Please login/signup to see your Orders";
        var logo = Utils.getLogoUrl(this.props.businessData);
        var order = this.props.order;
        var width = window.innerWidth;
        var isMobile = width < 993 ? true : false;

        var component = _react2.default.createElement(
            'section',
            { className: 'section pt-3 mt-4 mb-3 pb-2 orderscreen-box' },
            _react2.default.createElement(
                'div',
                { className: "container" },
                _react2.default.createElement(
                    'div',
                    { className: "row" },
                    _react2.default.createElement(
                        'div',
                        { className: 'mx-auto col-md-8' },
                        _react2.default.createElement(
                            'div',
                            { className: 'pb-4 pt-3 osahan-invoice bg-white shadow-sm' },
                            _react2.default.createElement(
                                'div',
                                { className: "row" },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-sm-12 text-center' },
                                    this.getOrderStructure()
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-sm-12 color-styl font-bold mt-2 mb-3 text-center ', id: 'order-btn' },
                                    _parse2.default.User.current() ? _react2.default.createElement(_SpinButton2.default, {
                                        classNames: 'ml-2 btn btn-md rounded-sm btn-styl font-weight-bold px-4 ft-16',
                                        buttonText: 'View Orders',
                                        spinText: "Loading...",
                                        showSpinner: false,
                                        whenClicked: this.handleOrderSuccess,
                                        showIcon: true,
                                        iconClass: "icofont-list pr-1",
                                        tabIndex: 8
                                    }) : null,
                                    isMobile ? _react2.default.createElement(_SpinButton2.default, {
                                        classNames: 'btn btn-md rounded-sm btn-styl font-weight-bold ft-16 ml-1',
                                        buttonText: 'Back to Menu',
                                        spinText: "Loading...",
                                        showSpinner: false,
                                        whenClicked: this.redirectToMainPage,
                                        showIcon: true,
                                        iconClass: "icofont-circled-left fr-10 mr-1",
                                        tabIndex: 8
                                    }) : null
                                )
                            ),
                            !_parse2.default.User.current() ? _react2.default.createElement(
                                'div',
                                { className: "row" },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-md-12 ' + (isMobile ? "px-4" : "px-5") },
                                    _react2.default.createElement(
                                        'table',
                                        { className: 'mt-2 mb-0 table' },
                                        _react2.default.createElement(
                                            'thead',
                                            { className: 'thead-light' },
                                            _react2.default.createElement(
                                                'tr',
                                                null,
                                                _react2.default.createElement(
                                                    'th',
                                                    { className: 'text-black font-weight-bold', scope: 'col' },
                                                    'Item Name'
                                                ),
                                                _react2.default.createElement(
                                                    'th',
                                                    { className: 'text-right text-black font-weight-bold', scope: 'col' },
                                                    'Quantity'
                                                ),
                                                _react2.default.createElement(
                                                    'th',
                                                    { className: 'text-right text-black font-weight-bold', scope: 'col' },
                                                    'Price'
                                                )
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'tbody',
                                            null,
                                            this.renderItemsDetail(),
                                            this.getCouponStructure(order.orderDetail),
                                            this.getDeliveryFeeStructure(order.orderDetail),
                                            _react2.default.createElement(
                                                'tr',
                                                null,
                                                _react2.default.createElement(
                                                    'td',
                                                    { className: 'text-right', colSpan: '2' },
                                                    'Tax:'
                                                ),
                                                _react2.default.createElement(
                                                    'td',
                                                    { className: 'text-right' },
                                                    '  $',
                                                    Utils.toRoundStr(order.orderDetail.taxes, 2)
                                                )
                                            ),
                                            this.getServiceFeeStructure(order.orderDetail),
                                            this.getDriverTipStructure(order.orderDetail),
                                            this.getCustomChargeStructure(order.orderDetail),
                                            _react2.default.createElement(
                                                'tr',
                                                null,
                                                _react2.default.createElement(
                                                    'td',
                                                    { className: 'text-right', colSpan: '2' },
                                                    _react2.default.createElement(
                                                        'h6',
                                                        { className: 'color-styl font-weight-bold' },
                                                        'Total:'
                                                    )
                                                ),
                                                _react2.default.createElement(
                                                    'td',
                                                    { className: 'text-right' },
                                                    _react2.default.createElement(
                                                        'h6',
                                                        { className: 'color-styl font-weight-bold' },
                                                        '  $',
                                                        Utils.toRoundStr(order.orderDetail.totalAmount, 2)
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            ) : null
                        )
                    )
                )
            )
        );

        return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_Spinner2.default, null),
            component
        );
    }
});

//create highter order component.
var HOC_SUCCESS_NAVIGATE = withOrderSuccessRouter(OrderSuccessScreen);
exports.default = HOC_SUCCESS_NAVIGATE;

// export default OrderSuccessScreen;


//////////////////
// WEBPACK FOOTER
// ./src/components/common/OrderSuccessScreen.jsx
// module id = 738
// module chunks = 0